import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian báo cáo: ", -1)
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_6 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_10 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "BÁO CÁO THỐNG KÊ TIÊM VẮC XIN PHÒNG DẠI VÀ HUYẾT THANH KHÁNG DẠI" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Calendar, {
                modelValue: $setup.baoCao.thoiGianBaoCao,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCao.thoiGianBaoCao) = $event)),
                touchUI: "",
                view: "month",
                dateFormat: "mm/yy"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_DataTable, {
                value: $setup.baoCao.baoCaos,
                showGridlines: "",
                rows: 40,
                rowHover: true,
                style: {"font-size":"14px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "TT",
                            rowspan: 2,
                            style: {"width":"5px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Điểm tiêm",
                            rowspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Giới",
                            colspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Tuổi",
                            colspan: 4
                          }),
                          _createVNode(_component_Column, {
                            header: "T.gian từ lúc bị cắn- tiêm",
                            colspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Loại động vật",
                            colspan: 4
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người có vị trí vết thương",
                            colspan: 4
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người có mức độ vết thương",
                            colspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Tình trạng động vật",
                            colspan: 4
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người",
                            colspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người dùng HTKD",
                            rowspan: 2,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người có phản ứng tại chỗ tiêm",
                            colspan: 4
                          }),
                          _createVNode(_component_Column, {
                            header: "Số người có phản ứng toàn thân sau tiêm",
                            colspan: 6
                          }),
                          _createVNode(_component_Column, {
                            header: "BN tử vong",
                            colspan: 2
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Nam",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Nữ",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "<15 tuổi",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "15 - 24 tuổi",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "25 - 49 tuổi",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: ">= 50 tuổi",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "<10 ngày",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: ">=10ngày",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Chó",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Mèo",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Dơi",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Khác",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Đầu mặt cổ",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Thân",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Tay",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Chân",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Độ I",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Độ II",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Độ III",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Bình thường",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Ốm",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Chạy rông +  mấttích",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Lên cơn dại",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Tiêm trong da",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Tiêm bắp",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Đau",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Quầng đỏ",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Tụ máu",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Phù nề/ nốt cứng",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Sốt",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Khó chịu",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Ngứa mẫn đỏ",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Đau cơ, khớp",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Rối loạn tiêu hóa",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Khác",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Có tiêm",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Không tiêm",
                            colspan: 1,
                            style: {"writing-mode":"vertical-rl"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "",
                    style: {"width":"5px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSo",
                    header: "Tổng số"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("label", null, _toDisplayString(slotProps.data.diemTiem), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "soTrucThuoc",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.nam,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.nam) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "soCSCoYeuToCoHai",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.nu,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.nu) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoCoSo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.duoi15Tuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.duoi15Tuoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongNuCoSo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tu15Den24Tuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tu15Den24Tuoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoCoSoCoYeuTo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tu25Den49Tuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tu25Den49Tuoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongNuCoSoCoYeuTo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tren50Tuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tren50Tuoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.duoi10Ngay,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.duoi10Ngay) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tren10Ngay,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tren10Ngay) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.cho,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.cho) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.meo,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.meo) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.doi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.doi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.khac,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.khac) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.dauMatCo,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.dauMatCo) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.than,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.than) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tay,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tay) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.chan,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chan) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.doI,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.doI) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.doII,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.doII) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.doIII,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.doIII) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.binhThuong,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.binhThuong) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.om,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.om) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.chayRong,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chayRong) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.lenConDai,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.lenConDai) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tiemTrongDa,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tiemTrongDa) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tiemBap,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tiemBap) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNguoiDungHTKD,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNguoiDungHTKD) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.dau,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.dau) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.quanDo,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.quanDo) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tuMau,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuMau) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.phuNe,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuNe) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.sot,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.sot) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.khoChiu,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.khoChiu) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.nguaManDo,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.nguaManDo) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.dauCo,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.dauCo) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.roiLoanTieuHoa,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.roiLoanTieuHoa) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.khacToanThan,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.khacToanThan) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.coTiem,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.coTiem) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.khongTiem,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.khongTiem) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ColumnGroup, { type: "footer" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            footer: "Tổng cộng",
                            colspan: 2,
                            footerStyle: "text-align:left"
                          }),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(1)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(2)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(3)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(4)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(5)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(6)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(7)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(8)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(9)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(10)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(11)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(12)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(13)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(14)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(15)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(16)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(17)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(18)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(19)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(20)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(21)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(22)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(23)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(24)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(25)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(26)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(27)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(28)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(29)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(30)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(31)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(32)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(33)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(34)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(35)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(36)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(37)
                          }, null, 8, ["footer"]),
                          _createVNode(_component_Column, {
                            footer: $setup.totalVacxin(38)
                          }, null, 8, ["footer"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                label: "Gởi báo cáo",
                icon: "pi pi-upload",
                severity: "secondary",
                raised: "",
                onClick: $setup.addReport
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}